"use client";

import {
  LineChart,
  Send,
  Code2,
  UserRound,
  Globe,
} from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { categoryTint } from "@/lib/status-tokens";

// Source kinds are categorical (not status), so they take distinct chart tints.
const sourceConfig: Record<
  string,
  { label: string; icon: typeof LineChart; className: string }
> = {
  TradingView: {
    label: "TradingView",
    icon: LineChart,
    className: categoryTint(0),
  },
  Telegram: {
    label: "Telegram",
    icon: Send,
    className: categoryTint(1),
  },
  Api: {
    label: "API",
    icon: Code2,
    className: categoryTint(2),
  },
  Manual: {
    label: "Manual",
    icon: UserRound,
    className: categoryTint(3),
  },
  Webhook: {
    label: "Webhook",
    icon: Globe,
    className: categoryTint(4),
  },
};

interface SourceTypeBadgeProps {
  sourceType: string;
}

export function SourceTypeBadge({ sourceType }: SourceTypeBadgeProps) {
  const config = sourceConfig[sourceType] ?? sourceConfig.Webhook;
  const Icon = config.icon;

  return (
    <Badge variant="outline" className={config.className}>
      <Icon className="me-1 h-3 w-3" />
      {config.label}
    </Badge>
  );
}
